module.exports = __webpack_public_path__ + "img/imposta-logo-emt.d2424262.png";